/**
 * MB Popup Handler with Cookie Logic
 */
export function initMbPopup() {
  const container = document.querySelector('.mb-popup-container');
  const popup = container ? container.querySelector('.mb-popup') : document.querySelector('.mb-popup');

  if (!popup) {
    return;
  }

  const cookieNameFromMarkup = container
    ? container.getAttribute('data-popup-cookie-name')
    : popup.getAttribute('data-popup-cookie-name');
  const COOKIE_NAME = cookieNameFromMarkup && cookieNameFromMarkup.trim()
    ? cookieNameFromMarkup.trim()
    : 'mb_popup_shown';
  const COOKIE_DURATION = 30; // Tage
  let savedScrollY = 0;

  /**
   * Set Cookie
   */
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  /**
   * Get Cookie
   */
  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /**
   * Show popup
   */
  function showPopup() {
    // Prevent main page from scrolling when popup is open
    savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.width = '100%';

    if (container) {
      container.classList.add('mb-popup-container--visible');
    }

    popup.classList.add('mb-popup--visible');
    popup.style.display = 'block';
  }

  /**
   * Close popup on button click
   */
  function closePopup() {
    popup.classList.add('mb-popup--fade-out');

    if (container) {
      container.classList.remove('mb-popup-container--visible');
    }

    setTimeout(() => {
      popup.classList.remove('mb-popup--visible');
      popup.classList.remove('mb-popup--fade-out');
      popup.style.display = 'none';
      if (container) {
        container.style.display = 'none';
      }
      setCookie(COOKIE_NAME, 'true', COOKIE_DURATION);

      // Restore scroll position and allow scrolling again
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (typeof savedScrollY !== 'undefined') {
        window.scrollTo(0, savedScrollY);
      }
    }, 500);
  }

  /**
   * Check if popup should be shown
   */
  const popupShown = getCookie(COOKIE_NAME);
  
  if (!popupShown) {
    showPopup();
  } else {
    popup.style.display = 'none';
    if (container) {
      container.style.display = 'none';
    }
  }

  /**
   * Close button handler
   */
  const closeBtn = container
    ? container.querySelector('.js-popup-close')
    : popup.querySelector('.js-popup-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closePopup();
    });
  }

  // Click outside popup (on overlay) closes popup
  if (container) {
    container.addEventListener('click', (e) => {
      if (e.target === container) {
        closePopup();
      }
    });
  }

  /**
   * Link click handler - Cookie setzen wenn auf Link geklickt wird
   */
  const popupLinks = Array.from(popup.querySelectorAll('.mb-popup-link'));
  if (popup.classList.contains('mb-popup-link')) {
    popupLinks.unshift(popup);
  }

  if (popupLinks.length > 0) {
    popupLinks.forEach((link) => {
      link.addEventListener('click', () => {
        setCookie(COOKIE_NAME, 'true', COOKIE_DURATION);
      });
    });
  }
}
